import { create } from 'zustand';
import { DISPLAY_TOAST_TIME, TOAST_ANIMATION_TIME } from '../constants/toast';
import { ToastState } from '../types/toast';

export const useToast = create<ToastState>((set, get) => ({
	isOpen: false,
	message: null,
	timer: null,

	handleShowToast: (message) => {
		const { timer, handleHideToast } = get();

		if (timer) {
			clearTimeout(timer);
		}

		const newTimer = setTimeout(() => {
			handleHideToast();
		}, DISPLAY_TOAST_TIME);

		set({ isOpen: true, message, timer: newTimer });
	},
	handleHideToast: () => {
		const { timer } = get();

		if (timer) {
			clearTimeout(timer);
		}

		set({ isOpen: false });

		setTimeout(() => {
			set({ message: null });
		}, TOAST_ANIMATION_TIME);
	},
}));
